import { Base } from '@studiometa/js-toolkit';

/**
 * Variant Radios
 */
export default class PickupAvailabilityDrawer extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'PickupAvailabilityDrawer',
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.onBodyClick = this.$el.handleBodyClick.bind(this);

    this.$el.querySelector('button').addEventListener('click', () => {
      this.hide();
    });
  }

  /**
   * Hide when ESC is pressed
   * @param  {object} event
   * @returns {void}
   */
  onKeyup(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
  }

  /**
   * Click on body
   * @param  {object} evt
   * @returns {void}
   */
  handleBodyClick(evt) {
    const { target } = evt;
    if (
      target !== this &&
      !target.closest('pickup-availability-drawer') &&
      target.id !== 'ShowPickupAvailabilityDrawer'
    ) {
      this.hide();
    }
  }

  /**
   * Hide panel
   * @returns {void}
   */
  hide() {
    this.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');
  }

  /**
   * Show panel
   * @param  {object} focusElement
   * @returns {void}
   */
  show(focusElement) {
    this.focusElement = focusElement;
    this.setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('overflow-hidden');
  }
}
